import { Fragment } from 'react';

import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './BlockStandards.module.scss';

type Props = {
  title?: string;
  theme?: 'light' | 'dark';
  className?: string;
};

const baseClass = 'block-standards';

const rawData = [
  { id: 1, name: ['ISO 27001', 'Compliant'] },
  { id: 2, name: ['ISO 27001', 'Certified'] },
  { id: 3, name: ['Hosting and Data processing in Europe'] },
  { id: 4, name: ['Built on Public and Trade Register Data'] },
  { id: 5, name: ['Full Transparency on Data Sources'] },
];

const data = rawData.map(({ id, name }) => ({
  id,
  name,
  icons: {
    light: `badges-${id + 13}`,
    dark: `badges-${id + 19}`,
  },
}));

export const BlockStandards = ({ title, theme = 'light', className }: Props) => {
  return (
    <section className={cn(styles[`${baseClass}-wrapper`], styles[`${baseClass}-${theme}`], className)}>
      <div className={styles[`${baseClass}-container`]}>
        {title && <TitleBlock title={title} theme={theme} />}

        <div className={styles[`${baseClass}-images`]}>
          {data.map((item) => (
            <div key={item.id} className={styles[`${baseClass}-item`]}>
              <Icon type={item.icons[theme]} style={{ fontSize: 88 }} />

              <p className={styles[`${baseClass}-name`]}>
                {item.name.map((text) => (
                  <Fragment key={text}>
                    {text}
                    <br />
                  </Fragment>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
